class CountdownTime extends HTMLElement {
  constructor() {
    super();

      this.countDownDate = new Date(this.dataset.countdown).getTime();
      this.container = document.querySelector('.announcement-sale-container');
      if (!Number(this.countDownDate)) this.countDownDate = new Date().setUTCHours(24,0,0,0);
      if(this.dataset.hide === "true" && this.countDownDate - new Date() <= 0) return this.hideCounter();
      
      this.init()

  }

  hideCounter(){
    this.classList.add("hidden");
    this.container && this.container.classList.add("hidden");
  }

  init(){
    this.daysElement = this.querySelector('#day');
    this.hoursElement = this.querySelector('#hour');
    this.minutesElement = this.querySelector('#minute');
    this.secondsElement = this.querySelector('#second');
    this.interval = setInterval(this.counter.bind(this), 1000);
  };

  counter(){
    
    
    const diffTime = this.countDownDate - new Date();
   

    if (diffTime < 0) {
      clearInterval(this.interval);
      
      if(this.dataset.hide === "true"){
              this.hideCounter();
      }
      return;
    }

    let days = Math.floor(diffTime / (1000 * 60 * 60 * 24))
    let hours = Math.floor((diffTime / (1000 * 60 * 60)) % 24)
    let minutes = Math.floor((diffTime / 1000 / 60) % 60)
    let seconds = Math.floor((diffTime / 1000) % 60)
   
        
    this.daysElement.innerHTML =  days < 10  ? `0${Math.max(days,0)}` : Math.max(days,0);
    this.hoursElement.innerHTML = hours < 10  ? `0${Math.max(hours,0)}` : Math.max(hours,0);
    this.minutesElement.innerHTML = minutes < 10 ? `0${Math.max(minutes,0)}` : Math.max(minutes,0);
    this.secondsElement.innerHTML = seconds < 10 ? `0${Math.max(seconds,0)}` : Math.max(seconds,0);
  }
}
customElements.define('countdown-time', CountdownTime);